// Global
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

// Components
import { StyledImage, StyledPhotoInfo, StyledUpload, StyledUploadContent } from './EditCategoryPhotoFieldStyles';
import { FormItem } from '@/components';
import { Button } from '@/ui';
import { RestoreClockIcon } from '@/icons';

// Models
import { ICategoryDetails } from '@/models/categories.model';

// Helpers
import { IMAGE_MIME_TYPES } from '@/constants/files';
import { EditCategoryFieldNames } from '../../helpers/types';
import { getCategoryImage } from '../../helpers/getCategoryImage';
import { validateCategoryImage } from '../../helpers/validateCategoryImage';

type TEditCategoryPhotoField = {
  categoryDetails: ICategoryDetails;
};

const EditCategoryPhotoField = ({ categoryDetails }: TEditCategoryPhotoField) => {
  const { t } = useTranslation(['categories']);

  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  return (
    <div>
      <FormItem
        name={EditCategoryFieldNames.PHOTO}
        valuePropName={EditCategoryFieldNames.PHOTO}
        label={t('category_photo')}
      >
        <StyledUpload
          maxCount={1}
          accept={IMAGE_MIME_TYPES}
          customRequest={(info) => setUploadedFile(info.file as File)}
          showUploadList={false}
          beforeUpload={(file) => validateCategoryImage(file, t)}
        >
          <StyledUploadContent>
            <StyledImage
              src={getCategoryImage(categoryDetails.photo, uploadedFile)}
              alt={categoryDetails.name}
              width={210}
              height={210}
            />
            <Button icon={<RestoreClockIcon />}>{t('upload_new_category_photo')}</Button>
          </StyledUploadContent>
        </StyledUpload>
      </FormItem>
      <StyledPhotoInfo>{t('recommended_category_photo_size')}</StyledPhotoInfo>
    </div>
  );
};

export default EditCategoryPhotoField;
